var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.avatarUrl)?_c('img',{style:(_vm.styleAttr),attrs:{"src":_vm.avatarUrl,"alt":""}}):_c('div',{style:(_vm.styleAttr)},[_c('account-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }